var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import classnames from 'classnames/bind';
import _ from 'lodash';
import QuickSearch from '../FindTheRightOil/QuickSearch';
import VehicleSearch from '../FindTheRightOil/VehicleSearch';
import OilSearch from '../FindTheRightOil/OilSearch';
import LicensePlateSearch from '../FindTheRightOil/LicensePlateSearch';
import '../../style/oil-search-styles.scss';
import style from './index.module.scss';
import instance from '../../services/httpRequest';
import localesReplacement from '../../utils/localesReplacement';
import IconOil from '../../images/oil.svg';
import IconOilSelected from '../../images/oil-selected.svg';
import IconCar from '../../images/icon-car.svg';
import IconLicensePlate from '../../images/license-plate-search.svg';
import IconLicensePlateSelected from '../../images/license-plate-search-selected.svg';
import IconCarSelected from '../../images/icon-car-selected.svg';
import IconClockFastrack from '../../images/icon-clock-fastrack.svg';
import IconClockFastrackSelected from '../../images/icon-clock-fastrack-selected.svg';
import { ENABLEDWORKSHOPSOWNER, ENABLED_LICENSE_PLATE_COUNTRIES, GLOBALFONTFAMILY } from '../../constants';
import OwnerSelector from '../OwnerSelector';
import { isQuickSearchDisabled } from '../../utils/isQuickSearchDisabled';
var cx = classnames.bind(style);
var SEARCH_TITLE_QUICK_SEARCH = 'Quick search';
var SEARCH_TITLE_VEHICLE_SEARCH = 'Vehicle search';
var SEARCH_TITLE_OIL_SEARCH = 'Oil search';
var SEARCH_TITLE_LICENSE_PLATE_SEARCH = 'License Plate Search';
var defaultTypes = [
    {
        title: SEARCH_TITLE_QUICK_SEARCH,
        icon: IconClockFastrack,
        alt: 'icon click fastrack',
        iconSelected: IconClockFastrackSelected,
        classname: 'quickSearch',
    },
    {
        title: SEARCH_TITLE_VEHICLE_SEARCH,
        haveSeparator: true,
        icon: IconCar,
        iconSelected: IconCarSelected,
        alt: 'icon car',
        classname: 'vehicleSearch',
    },
    {
        title: SEARCH_TITLE_OIL_SEARCH,
        icon: IconOil,
        iconSelected: IconOilSelected,
        alt: 'icon oil',
        classname: 'oilSearch',
    },
];
function FindTheRightOil(props) {
    var baseAPI = props.baseAPI, country = props.country, i18n = props.i18n, locales = props.locales, onWTBClick = props.onWTBClick, restore = props.restore, preserved = props.preserved, rest = __rest(props, ["baseAPI", "country", "i18n", "locales", "onWTBClick", "restore", "preserved"]);
    var _a = useState(SEARCH_TITLE_QUICK_SEARCH), searchType = _a[0], setSearchType = _a[1];
    // eslint-disable-next-line
    var _b = useState(defaultTypes), types = _b[0], setTypes = _b[1];
    //Get vehicles & product data
    if (baseAPI) {
        instance.defaults.baseURL = baseAPI;
    }
    if (country) {
        _.assign(instance.defaults.headers, { countryCode: country });
    }
    if (i18n) {
        _.assign(instance.defaults.headers, { languageCode: i18n });
    }
    var _c = useState({}), replacements = _c[0], setReplacements = _c[1];
    useEffect(function () {
        if (locales) {
            setReplacements(locales);
        }
    }, [locales]);
    var _d = useState(sessionStorage.getItem('selectedType') === 'true' ? true : false), selectedIndex = _d[0], setSelectedIndex = _d[1];
    var window = globalThis;
    window.dataLayer = window.dataLayer || [];
    var controller = new AbortController();
    var _e = useState(false), licence = _e[0], setLicence = _e[1];
    var _f = useState(false), recaptcha = _f[0], setRecaptcha = _f[1];
    var _g = useState(false), smartSearch = _g[0], setSmartSearch = _g[1];
    var _h = useState(''), licensePlateRegexes = _h[0], setLicensePlateRegexes = _h[1];
    var _j = useState(''), type = _j[0], setType = _j[1];
    var _k = useState(false), wtb = _k[0], setWtb = _k[1];
    useEffect(function () {
        window.dataLayer.push({
            'event': 'productFinderView',
            'userType': selectedIndex ? 'workshop owner' : 'vehicle owner',
            'countryCode': country,
            'pageType': 'product finder',
        });
        if (_.includes(ENABLED_LICENSE_PLATE_COUNTRIES, country) || !smartSearch) {
            var usaTypes = __spreadArray([], defaultTypes, true);
            usaTypes.splice(1, 0, {
                title: SEARCH_TITLE_LICENSE_PLATE_SEARCH,
                icon: IconLicensePlate,
                iconSelected: IconLicensePlateSelected,
                alt: 'icon license plate',
                classname: 'licensePlateSearch',
            });
            setTypes(usaTypes);
        }
        else {
            setTypes(defaultTypes);
        }
        if (isQuickSearchDisabled(country)) {
            var newTypes = defaultTypes.filter(function (item) { return item.title !== SEARCH_TITLE_QUICK_SEARCH; });
            setTypes(newTypes);
        }
        if (_.isEqual(country, 'TUR')) {
            setSearchType(SEARCH_TITLE_VEHICLE_SEARCH);
        }
    }, [smartSearch]);
    useEffect(function () {
        instance
            .get('/data/countrySettings/currentCountrySetting', {
            signal: controller.signal,
        })
            .then(function (d) {
            if (d) {
                setLicence(d.data.licensePlateSearchEnabled);
                setRecaptcha(d.data.captchaEnabled);
                setSmartSearch(d.data.enableSmartSearch);
                setLicensePlateRegexes(d.data.licensePlateRegexes);
                setType(d.data.serviceProvider);
                setWtb(d.data.whereToBuyForLandingEnabled);
            }
        });
        return function () {
            controller.abort();
        };
    }, []);
    useEffect(function () {
        var r = _.find(GLOBALFONTFAMILY, function (item) {
            return _.includes(item.countries, i18n);
        });
        document.querySelector('#oil-search').style.setProperty('--font-family', (r === null || r === void 0 ? void 0 : r.fontFamily) ? r === null || r === void 0 ? void 0 : r.fontFamily : 'CastrolSans');
    }, [i18n]);
    //Restore from sessionStorage
    useEffect(function () {
        var _a;
        if (preserved) {
            setSearchType((_a = sessionStorage.getItem('searchTab')) !== null && _a !== void 0 ? _a : SEARCH_TITLE_QUICK_SEARCH);
        }
    }, [preserved]);
    return (_jsxs("div", __assign({ className: cx('section', 'castrol-oil-search'), id: 'oil-search' }, { children: [_jsxs("div", __assign({ className: cx('heading') }, { children: [_jsx("h3", { children: localesReplacement(replacements, 'Find the right product') }, void 0), _jsx("p", { children: localesReplacement(replacements, 'With the Castrol Oil Selector it has never been easier to find out which oil is best for you.') }, void 0)] }), void 0), country && _.includes(ENABLEDWORKSHOPSOWNER, country) ? (_jsx(OwnerSelector, { replacements: replacements, selectedIndex: selectedIndex, setSelectedIndex: function (b) {
                    window.dataLayer.push({
                        'event': b ? 'workshopOwnerClicks' : 'vehicleOwnerClicks',
                        'countryCode': country
                    });
                    setSelectedIndex(b);
                    sessionStorage.setItem('selectedType', _.toString(b));
                } }, void 0)) : null, _jsxs("div", __assign({ className: cx('search-type') }, { children: [_jsx("ul", { children: _.map(types, function (t, index) { return (_jsx("li", __assign({ className: cx(t.classname) }, { children: _jsxs("label", { children: [_jsx("input", { type: 'radio', name: 'search-type', value: t.title, onChange: function () {
                                            setSearchType(t.title);
                                            localStorage.setItem('searchTab', t.title);
                                            if (restore) {
                                                sessionStorage.clear();
                                                sessionStorage.setItem('searchTab', t.title);
                                            }
                                        }, checked: _.isEqual(searchType, t.title) }, void 0), _jsxs("div", __assign({ className: cx('search-item') }, { children: [_jsx("div", { className: cx('bg') }, void 0), _jsx("img", { className: cx('icon'), src: t.icon, alt: t.alt }, void 0), _jsx("img", { className: cx('icon', 'selected'), src: t.iconSelected, alt: t.alt }, void 0), _jsx("span", { children: localesReplacement(replacements, t.title) }, void 0)] }), void 0), t.haveSeparator ? _jsx("div", { className: cx('separator') }, void 0) : null] }, void 0) }), index)); }) }, void 0), wtb && onWTBClick && !restore && (_jsx("button", __assign({ onClick: function () {
                            onWTBClick && onWTBClick();
                        } }, { children: localesReplacement(replacements, 'Where to Buy') }), void 0))] }), void 0), !isQuickSearchDisabled(country) && _.isEqual(searchType, SEARCH_TITLE_QUICK_SEARCH) && (_jsx(QuickSearch, __assign({ language: i18n, replacements: replacements, switchVehicleSearch: function () { return setSearchType(SEARCH_TITLE_VEHICLE_SEARCH); }, country: country, licence: licence && smartSearch, licensePlateRegexes: licensePlateRegexes, selectedWorkshop: _.includes(ENABLEDWORKSHOPSOWNER, country) ? selectedIndex : false, captcha: recaptcha, restore: restore, preserved: preserved, userType: selectedIndex }, rest), void 0)), _.isEqual(searchType, SEARCH_TITLE_VEHICLE_SEARCH) && (_jsx(VehicleSearch, __assign({ replacements: replacements }, rest, { categoriesType: type, selectedWorkshop: _.includes(ENABLEDWORKSHOPSOWNER, country) ? selectedIndex : false, restore: restore, preserved: preserved }), void 0)), _.isEqual(searchType, SEARCH_TITLE_OIL_SEARCH) && (_jsx(OilSearch, __assign({ replacements: replacements }, rest, { selectedWorkshop: _.includes(ENABLEDWORKSHOPSOWNER, country) ? selectedIndex : false, restore: restore, preserved: preserved }), void 0)), (_.includes(ENABLED_LICENSE_PLATE_COUNTRIES, country) || !smartSearch) &&
                _.isEqual(searchType, SEARCH_TITLE_LICENSE_PLATE_SEARCH) && (_jsx(LicensePlateSearch, __assign({ country: country, language: i18n, replacements: replacements }, rest, { selectedWorkshop: _.includes(ENABLEDWORKSHOPSOWNER, country) ? selectedIndex : false, captcha: recaptcha }), void 0))] }), void 0));
}
export default FindTheRightOil;
